import { BalanceApi, UserApi } from '../api-typings/users/users';
import { transformCurrency } from '../currency/currency.transformers';
import { User, UserBalance, UserPendingFunds } from './user.model';

export function transformUser(user: UserApi): User {
  if (
    !user.id ||
    !user.username ||
    !user.avatar ||
    !user.avatar_large ||
    !user.role
  ) {
    throw new ReferenceError(`Missing a required user field.`);
  }

  const displayName: string =
    user.support_status && user.support_status.short_name
      ? user.support_status.short_name
      : user.public_name || user.display_name || user.username;
  return {
    id: user.id,
    avatar: transformUserImage(user.avatar),
    avatarLarge: transformUserImage(user.avatar_large),
    supportStatus: user.support_status,
    username: user.username,
    displayName,
    role: user.role,
    profileUrl: `/u/${user.username}`,
  };
}

export function transformUserImage(image: string): string | undefined {
  return image !== '/img/unknown.png' ? image : undefined;
}

export function transformUserBalance(
  balance: BalanceApi,
  user: UserApi,
): UserBalance | undefined {
  if (balance.currency) {
    const isPrimaryCurrency =
      !!user.primary_currency &&
      balance.currency.code === user.primary_currency.code;
    // If the balance is 0 don't return the balance information
    // unless if the currency is the user's primary currency.
    if (balance.amount !== 0 || isPrimaryCurrency) {
      return {
        id: balance.currency.id,
        currency: transformCurrency(balance.currency),
        amount: balance.amount || 0,
        primary: isPrimaryCurrency,
      };
    }
  }
}

export function transformPendingFunds(
  pendingFunds: BalanceApi,
  user: UserApi,
): UserPendingFunds | undefined {
  return pendingFunds.currency
    ? {
        id: pendingFunds.currency.id,
        currency: transformCurrency(pendingFunds.currency),
        amount: pendingFunds.amount || 0,
      }
    : undefined;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/datastore/user/user.transformers.ts